"use strict";

var formatNumber = require("./number.formatter");
var formatDate = require("./date.formatter");
var debug = require("debug")("knack.formatter.formatters.equation");
var _ = require("lodash");
var formatEquationRaw = function formatEquationRaw(value, format) {
  if (format && format.equation_type && format.equation_type === "date") {
    var format_type = "date";
    if (format.date_result) {
      format_type = format.date_result;
    } else if (value < 10000000000) {
      format_type = "number";
    }

    // format as date
    // only divide if this was a big number (division in a date equation is going to nullify this)
    if (format_type === "number") {
      switch (format.date_type) {
        case "days":
          value = value / (60 * 60 * 24);
          break;
        case "hours":
          value = value / (60 * 60);
          break;
        case "weeks":
          value = value / (60 * 60 * 24 * 7);
          break;
        case "years":
          value = value / (60 * 60 * 24 * 365.25);
          break;
      }
    }
  }
  return value;
};

/**
 * @alias "formatters.equation"
 * @param {Number} value
 * @param {Object} format
 * @param {String} format.equation_type `date`, `number`
 * @param {Boolean} [format.date_result] if return value should be a date
 * @return {String}
 */
var equationFormatter = function equationFormatter(value, format) {
  value = formatEquationRaw(value, format);
  if (format && format.equation_type && format.equation_type === "date") {
    var format_type = "date";
    if (format.date_result) {
      format_type = format.date_result;
    } else if (value < 10000000000) {
      format_type = "number";
    }

    // format as date
    if (format_type === "date") {
      if (_.isNumber(value)) {
        value = value * 1000;
      }
      return formatDate(value, format);
    }
    return formatNumber(value, format);
  }
  return formatNumber(value, format);
};
module.exports = equationFormatter;